import React from 'react';
import { Alert } from "@mui/material";
import useAuth from "../../../hooks/useAuth";

function AIChat() {
    const { currentBrand, currentEstablishment } = useAuth();

    if (!currentEstablishment() || !currentBrand()) {
        return (
            <Alert severity="warning">
                Veuillez sélectionner une marque et un établissement pour accéder au chat IA.
            </Alert>
        );
    }

    // Le composant FullPageChat est maintenant géré au niveau du layout
    // Cette page sert juste de placeholder et de vérification des prérequis
    return null;
}

export default AIChat;